import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import isQuerySensitive from './isQuerySensitive';

// a hook that constructs intro messages for hotels search results chatbot
const useHotelsSearchResultsUtils = () => {
  const hotelPins = useSelector((store) => store.tripSearch.searchResult?.hotelPins);
  const { generalInfo, utilFunctions } = useMemo(() => {
    let info = '';
    if (!hotelPins || hotelPins.length === 0) {
      return { generalInfo: info, utilFunctions: null };
    }
    for (let i = 0; i < hotelPins.length; i += 1) {
      const hotelPin = hotelPins[i];
      info += `Hotel name is ${hotelPin.name}, Total cost for the stay: ${hotelPin.cost}, Average nightly rate: ${hotelPin.averageNightlyRate}${hotelPin.currencyCode}, Hotel Addresses: latitude: ${hotelPin.latitude},longitude: ${hotelPin.longitude}, and the hotel is listed on page ${hotelPin.pageNumber} of the search results.`;
    }
    info += `Total hotels listed: ${hotelPins.length}`;
    const utils = {
      isQueryRelevant: () => null,
      isQuerySensitive: (query) => isQuerySensitive(query),
    };
    return { generalInfo: info, utilFunctions: utils };
  }, [hotelPins]);

  return { generalInfo, utilFunctions };
};

export default useHotelsSearchResultsUtils;
